import { render, staticRenderFns } from "./menuButton.vue?vue&type=template&id=74d6a2d6&scoped=true&"
import script from "./menuButton.vue?vue&type=script&lang=js&"
export * from "./menuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d6a2d6",
  null
  
)

export default component.exports